export const Unhandled15Regular = ({strokeColor = "currentColor"}) => {
	return (
		<svg
			width="15"
			height="15"
			viewBox="0 0 15 15"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"			
		>
			<path
				d="M14 1L10.5 4.5M7 8L10.5 4.5M10.5 4.5L7 1M10.5 4.5L14 8"
				stroke={strokeColor}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M4 4H3C1.89543 4 1 4.89543 1 6V12C1 13.1046 1.89543 14 3 14H10C11.1046 14 12 13.1046 12 12V11"
				stroke={strokeColor}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
